import React from 'react'
//import apiClient from '../../services/apiClient'
import {
  CButton,
  //CCard,
  //CBadge,
  CCardBody,
  //CCardTitle,
  CCardText,
  CCol,
  //CRow,
  //CImage,
  //CForm,
  CFormInput,
  CInputGroup,
  CInputGroupText,
  //CFormCheck,
} from '@coreui/react'
//import { cilList } from '@coreui/icons'
//import CIcon from '@coreui/icons-react'
//import aoiPic1 from 'src/assets/devices/car.jpeg'
//import { useNavigate } from 'react-router-dom'

const WidgetRow = () => {
  return (
    <CInputGroup className="mb-3">
      <CCol xs={2} sm={1} md={1} lg={1} xl={1} xxl={1}>
        <CInputGroupText>@</CInputGroupText>
      </CCol>
      <CCol xs={5} sm={5} md={5} lg={2} xl={2} xxl={2}>
        <CFormInput type="text" id="idno" name="idno" placeholder="Room" autoComplete="idno" />
      </CCol>
      <CCol xs={5} sm={6} md={6} lg={2} xl={2} xxl={2}>
        <CFormInput type="text" id="idno" name="idno" placeholder="Device" autoComplete="idno" />
      </CCol>
      <CCol xs={8} sm={3} md={3} lg={2} xl={2} xxl={1}>
        <CInputGroup className="mb-3">
          <CButton
            color="primary"
            onClick={() => {
              //localStorage.removeItem('loginName1')
              //localStorage.removeItem('wizard')
              console.log('Form sent')
            }}
          >
            -
          </CButton>
          <CFormInput type="text" id="idno" name="idno" placeholder="1" autoComplete="idno" />
          <CButton
            color="primary"
            onClick={() => {
              //localStorage.removeItem('loginName1')
              //localStorage.removeItem('wizard')
              console.log('Form sent')
            }}
          >
            +
          </CButton>
        </CInputGroup>
      </CCol>
      <CCol xs={2} sm={1} md={1} lg={1} xl={1} xxl={1}>
        <CCardBody>
          <CCardText>
            <small>#</small>
          </CCardText>
        </CCardBody>
      </CCol>
      <CCol xs={8} sm={3} md={3} lg={2} xl={2} xxl={1}>
        <CInputGroup className="mb-3">
          <CButton
            color="primary"
            onClick={() => {
              //localStorage.removeItem('loginName1')
              //localStorage.removeItem('wizard')
              console.log('Form sent')
            }}
          >
            -
          </CButton>
          <CFormInput type="text" id="idno" name="idno" placeholder="8" autoComplete="idno" />
          <CButton
            color="primary"
            onClick={() => {
              //localStorage.removeItem('loginName1')
              //localStorage.removeItem('wizard')
              console.log('Form sent')
            }}
          >
            +
          </CButton>
        </CInputGroup>
      </CCol>
      <CCol xs={4} sm={2} md={2} lg={1} xl={1} xxl={1}>
        <CCardBody>
          <CCardText>
            <small>kW</small>
          </CCardText>
        </CCardBody>
      </CCol>
      <CCol xs={8} sm={2} md={2} lg={1} xl={1} xxl={1}>
        <CCardBody>
          <CCardText>
            <small>8 kW</small>
          </CCardText>
        </CCardBody>
      </CCol>
    </CInputGroup>
  )
}

export default WidgetRow
